import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["submitButton"]
  static values  = {
    actionLabel:      String,
    submittingLabel:  String
  }

  connect() {
    this.element.querySelectorAll('.pe-slot-input').forEach(radio => {
      radio.addEventListener('change', () => this.onSlotSelected())
    })
    this.element.addEventListener('submit', () => this.onSubmit())
  }

  onSlotSelected() {
    const selected = this.element.querySelector('.pe-slot-input:checked')
    if (!selected) return

    const label = this.element.querySelector(`label[for="${selected.id}"] .pe-slot-time`)
    const slotTime = label ? label.textContent.trim() : 'this slot'

    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.textContent = `${this.actionLabelValue} ${slotTime} →`
  }

  onSubmit() {
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.textContent = this.submittingLabelValue
  }
}
